import React, { useEffect, useState, useRef } from "react";
import { useParams, Link } from "react-router-dom";
import blog_1 from '../assets/img/Blogs/blog_hero_1.jpg';
import { useBlogContext } from './BlogContext';
// import DOMPurify from 'dompurify';w

// const SafeHTMLRenderer = ({ htmlContent }) => {
//   return (
//     <div 
//       className="html-content-container"
//       dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(htmlContent) }}
//     />
//   );
// };

const HTMLContentRenderer = ({ htmlContent }) => {
    const containerRef = useRef(null);
    const [filteredContent, setFilteredContent] = useState("");
  
    useEffect(() => {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = htmlContent;
    
        // const images = tempDiv.querySelectorAll("img");
        // images.forEach((img) => img.remove());

        const brs = tempDiv.querySelectorAll("br");
        brs.forEach((br) => br.remove());
    
        setFilteredContent(tempDiv.innerHTML);
    }, [htmlContent]);
  
    return (
      <div
        ref={containerRef}
        className="html-content-container"
        dangerouslySetInnerHTML={{ __html: filteredContent }}
      />
    );
};

const ImageOnlyRenderer = ({ htmlContent }) => {
    const [images, setImages] = useState([]);
  
    useEffect(() => {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = htmlContent;
    
        const imgTags = tempDiv.querySelectorAll("img");
        const imgElements = Array.from(imgTags).map((img, index) => ({
            src: img.src,
            alt: img.alt || `image-${index}`,
        }));
    
        setImages(imgElements);
    }, [htmlContent]);
  
    return (
      <div className="image-only-container">
        {images.map((img, idx) => (
          <img
            key={idx}
            src={img.src}
            alt={img.alt}
            style={{
                width: "100%",
                maxHeight: "500px",
                objectFit: "cover",
                borderRadius: "8px",
                marginBottom: "1rem"
            }}
          />
        ))}
      </div>
    );
};


function formatDateWithSuffix(date) {
    const day = new Date(date).getDate();
    const suffix = (day) => {
        if (day > 3 && day < 21) return 'th'; 
        switch (day % 10) {
            case 1: return 'st';
            case 2: return 'nd';
            case 3: return 'rd';
            default: return 'th';
        }
    };
  
    const formattedDate = new Date(date).toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  
    return formattedDate.replace(/\d+/, (match) => `${match}${suffix(day)}`);
}

const BlogView = () => {
    const { id } = useParams();
    const { blogs } = useBlogContext();
    const [blogPost, setBlogPost] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const findBlog = () => {
            if (blogs.length > 0) {
                const foundBlog = blogs.find(item => item.id === id);
                if (foundBlog) {
                    setBlogPost(foundBlog);
                } else {
                    setError("Blog post not found");
                }
                setLoading(false);
            }
        };
    
        if (blogs.length > 0) {
            findBlog();
        } else if (!loading) {
            setError("No blogs available");
            setLoading(false);
        }
    }, [id, blogs, loading]);


    if (loading) {
        return (
            <div id="loader" className="pageOverlay">
                <div className="lm-preload">
                    <div className="lm-item lm-item-1"></div>
                    <div className="lm-item lm-item-2"></div>
                    <div className="lm-item lm-item-3"></div>
                    <div className="lm-item lm-item-4"></div>
                    <div className="lm-item lm-item-5"></div>
                </div>
            </div>
        )
    }

    if (error) {
        return (
            <div className="blog-view-error" style={{ padding: '100px 0', textAlign: 'center' }}>
                <h2>{error}</h2>
                <Link to="/blogs" className="back-button" style={{ 
                    display: 'inline-block', 
                    padding: '10px 20px', 
                    backgroundColor: '#dcdfe0', 
                    color: '#333',
                    textDecoration: 'none',
                    marginTop: '20px',
                    borderRadius: '4px'
                }}>
                    Back to Blogs
                </Link>
            </div>
        );
    }

    const renderFields = (fields, section_seq, col) => {
        return <div>
            {fields && fields.length > 0 && fields
                .filter(fitem => fitem.section_seq === section_seq && fitem.col === col && fitem.status_id === 'ACTIVE')
                .map((fitem, findex) => {
                    let _props = fitem.props;
                    fitem = { ...fitem, ..._props };
                    return <div key={section_seq + "_" + fitem.seq + "_" + findex} style={{ clear: "both" }} >

                        {fitem.field_type.label === "Generic Field" && fitem.component.value === 'Text' &&
                            <div className="p-3">
                                <div style={{ fontWeight: "600", fontSize: "1.1em",textAlign: fitem.alignment.value.toLowerCase() }}>{fitem.field_label}</div>
                                <div style={{ textAlign: fitem.alignment.value.toLowerCase() }}>{fitem.label_text}</div>
                                
                                <div className="message-body" style={{ width:'100%' }}>
                                    <div className="datasheet-content" dangerouslySetInnerHTML={{ __html: fitem.content }} > 
                                    
                                        {/* <HTMLContentRenderer htmlContent={fitem.content}/> */}
                                    </div>
                                </div>

                            </div>
                        }
                    </div>
                })}
        </div>
    }

    return (
        <div className="portifoliobody">
            <main id="main">
                <section id="blog-view" className="blog-detail">
                    <div className="container">
                        <div>
                            <div className="blog-header">
                                <div className="blog-meta">
                                    {/* <div>{blogPost.created_by_name ? blogPost.created_by_name : ''}</div> */}
                                    <div>Posted on {formatDateWithSuffix(blogPost.created_at_dt)}</div>
                                </div>
                                <h1>{blogPost.blog_title}</h1>
                            </div>
                        </div>

                        {/* <div className="blog-image" style={{ marginBottom: '30px' }}> */}
                            {/* <img 
                                src={blog_1}
                                alt={blogPost.blog_title} 
                                style={{ width: '100%', maxHeight: '500px', objectFit: 'cover', borderRadius: '8px' }} 
                            /> */}
                            {/* <ImageOnlyRenderer htmlContent={blogPost}/>
                        </div> */}

                        <div style={{ marginBottom: '30px' }}>
                            {blogPost.sections && blogPost.sections.length > 0 && blogPost.sections.filter(item => item.status_id === 'ACTIVE').map((item, index) => {
                                return <div className="columns break-avoid" key={index + '_' + item.seq} >
                                    <div className="column">
                                        <div className="card card-view">
                                            {/* <div className="card-header" style={{backgroundColor:'transparent', borderBottom:'none', textAlign:'left', width:'100%'}}>
                                            <h1> <b className='is-uppercase'>{item.section_label}</b> </h1>
                                            </div> */}
                                            {/* <div>{item.show_section_label}</div> */}
                                            <div className="card-content">
                                                <div className="columns m-0" style={{display:'flex'}}>
                                                    <div className="column p-3 mx-2" style={{ background: "#ffffff", overflowY: "auto", wordWrap: "break-word" }}>
                                                        {renderFields(blogPost.fields, item.seq, 1)}
                                                    </div>
                                                    {item.cols > 1 && (
                                                        <div className="column p-3 mx-2" style={{ background: "#ffffff", overflowY: "auto", wordWrap: "break-word" }}>
                                                            {renderFields(blogPost.fields, item.seq, 2)}
                                                        </div>
                                                    )}
                                                    {item.cols > 2 && (
                                                        <div className="column p-3 mx-2" style={{ background: "#ffffff", overflowY: "auto", wordWrap: "break-word" }}>
                                                            {renderFields(blogPost.fields, item.seq, 3)}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            })}
                        </div>
                        
                        {/* <div style={{padding:'3rem 15rem'}}>
                            <div className="blog-content" style={{ 
                                lineHeight: '1.8',
                                fontSize: '16px',
                                marginBottom: '40px'
                            }}>
                                // <p>{blogPost.blog_post_content}</p>
                                
                                // <p style={{ marginTop: '20px' }}>{blogPost.full_content}</p>
                                // <HTMLContentRenderer htmlContent={blogPost.blog_content}/>
                                
                                // <p style={{ marginTop: '20px' }}>
                                //     However, online pharmacy services are not without potential drawbacks. Questions about quality control, 
                                //     the authenticity of medications, data privacy, and the loss of face-to-face consultation with pharmacists 
                                //     remain significant concerns. Additionally, the digital divide means that not everyone has equal access to these services, 
                                //     potentially exacerbating existing healthcare inequalities.
                                // </p>
                                
                                // <p style={{ marginTop: '20px' }}>
                                //     As the healthcare landscape continues to evolve alongside technological advancements, finding the right balance 
                                //     between digital convenience and patient safety will be crucial for the future development of pharmacy services. 
                                //     Regulatory frameworks will need to adapt to ensure that online pharmacies maintain the same standards of care 
                                //     as their brick-and-mortar counterparts.
                                // </p>
                            </div>
                        </div> */}
                        {
                            blogs.length === 1 ? (
                                <div></div>
                            ) : (
                                <div className="related-posts">
                                    <h3 style={{ marginBottom: '20px' }}>What to read next</h3>
                                    <div className="related-posts-grid" >
                                        {(() => {
                                            const filteredBlogs = blogs.filter(post => post.id !== id);
                                            
                                            const getRandomBlogs = (blogsArray, count) => {
                                                const shuffled = [...blogsArray];
                                                
                                                for (let i = shuffled.length - 1; i > 0; i--) {
                                                    const j = Math.floor(Math.random() * (i + 1));
                                                    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
                                                }
                                                return shuffled.slice(0, count);
                                            };
                                            
                                            const randomBlogs = getRandomBlogs(filteredBlogs, 4);
                                            
                                            return randomBlogs.map((post, index) => {
                                                let imageSrc = blog_1; // Default fallback image
                                                
                                                if (post.fields && post.fields.length > 0) {
                                                    const imageField = post.fields.find(field => 
                                                        field.content && typeof field.content === 'string' && field.content.includes('<img')
                                                    );
                                                    
                                                    if (imageField) {
                                                        const tempDiv = document.createElement('div');
                                                        tempDiv.innerHTML = imageField.content;
                                                        const imgElement = tempDiv.querySelector('img');
                                                        if (imgElement && imgElement.src) {
                                                            imageSrc = imgElement.src;
                                                        }
                                                    }
                                                }
                                                
                                                return (
                                                    <div key={index} className="related-post-card">
                                                        <Link to={`/blog/${post.id}`} href='#' style={{textDecoration:'none',overflow:'hidden'}}>
                                                            <img 
                                                                src={imageSrc} 
                                                                alt={post.blog_title} 
                                                                style={{ width: '100%', height: '150px', objectFit: 'cover' }}
                                                            />
                                                            <div style={{ padding: '15px' }}>
                                                                <h4 style={{ fontSize: '18px', marginBottom: '10px' }}>{post.blog_title}</h4>
                                                                <div className='learn-more-div blg-read-more'>
                                                                    {/* <Link to={`/blog/${post.id}`} href='#' style={{textDecoration:'none'}}>
                                                                        <div className='blg-read-more-btn' style={{backgroundColor:'#dcdfe0', padding:'5px 10px'}}>
                                                                            <span>Read more</span>
                                                                            <div className="arrow arrow--right">
                                                                                <span></span>
                                                                            </div>
                                                                        </div>
                                                                    </Link> */}
                                                                </div>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                );
                                            });
                                        })()}
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </section>
            </main>
        </div>
    );
};

export default BlogView;